module.exports = __webpack_public_path__ + "static/media/Hover4_Oklahoma.76281025.png";